const translation = {
  validations: {
    phone: 'Phone number is not valid',
  },
  general: {
    YES: 'YES',
    NO: 'NO',
    yes: 'yes',
    no: 'no',
  },
  status: {
    pendingC: 'Pending',
  },
  reset: {
    "title": "Reset Password",
    "backLogin": "Back to Login",
    "reset": "Reset Password",
    "success": "Password reset instructions sent",
    "successMessage": "Password reset instructions have been sent to your email",
    "emailNotFound": "Email address not found",
    "generalError": "Unable to reset password. Please try again.",
    "update": "Update Password",
  },
  login: {
    title: 'Log In',
    subtitle: 'Your workspace, your way',
    emailLabel: 'Email address',
    passwordLabel: 'Password',
    forgot: 'Forgot?',
    logIn: 'Log In',
    join: "Don't have an account? Join",
    error: 'Login error: Please check your credentials, and that your account is activated.',
    name: 'Name',
    or: 'or',
    noAccount: 'Don\'t have an account?',
    signUp: 'Sign up',
    googleError: 'Sorry, we cannot connect to Google. Please let us know if you still have issues.',
  },
  signup: {
    title: 'Sign Up',
    subtitle : 'Your productivity starts here.',
    firstName: "First Name",
    lastName: "Last Name",
    emailLabel: "Email Address",
    passwordLabel: "Create Password",
    firstNameRequired: "First name is required",
    lastNameRequired: "Last name is required",
    emailRequired: "Email is required",
    invalidEmail: "Invalid email address",
    passwordRequired: "Password is required",
    passwordTooShort: "Password must be at least 8 characters",
    passwordComplexity: "Password must include uppercase, lowercase, number, and special character",
    privacyPolicyAgreement: "I agree to the",
    privacyPolicy: "Privacy Policy",
    privacyPolicyRequired: "You must agree to the privacy policy",
    createAccount: "Create Account",
    alreadyHaveAccount: "Already have an account?",
    loginHere: "Log in",
    error: "Unable to create account. Please try again.",
    emailAlreadyExists: "User with this email address already exists.",
  },
  common: {
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    confirm: 'Confirm',
    close: 'Close',
    add: 'Add',
    update: 'Update',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    search: 'Search',
  },
  community: {
    role: {
      FO: 'Founder',
      AD: 'Admin',
      MA: 'Manager',
      PA: 'Participant',
      GU: 'Guest',
    }

  },
  event: {
    sections: {
      dashboard: 'Dashboard',
      events: 'Events',
    },
    join: 'Join event',
    joinDisclaimer: 'By filling this form you are joining the event as a guest. Once you submit the form, you should receive an email more details.',
    joinConfirm: 'Please press the button below if you want to join the event.',
    joinDuplicated: 'Sorry, you are already registered for this event. Please check your email for the event link.',
    full: 'Event full',
    update: 'Update Profile',
    bookingType: {
      BO: 'Group Booking',
      IN: 'Important Information',
      SE: 'Partner offer',
      PR: 'Featured project',
      ME: 'Featured member',
    },
  },
  campaign: {
    sections: {
      dashboard: 'Dashboard',
      campaigns: 'Campaigns',
    },
    send: 'Send',
    sendDisclaimer: 'By filling',
    campaignType: {
      EM: 'Email',
      SM: 'SMS',
      PU: 'Push',
      GU: 'Guests',
    },
    campaignTarget: {
      AL: 'All',
      PA: 'Participants',
      GU: 'Guests',
      AD: 'Admin',
    },
    campaignStatus: {
      PE: 'Pending',
      SE: 'Sent',
      FA: 'Failed',
      DR: 'Draft',
    },
  },
  drawer: {
    sections: {
      dashboard: 'Dashboard',
      events: 'Events',
    },
    notifications: 'Notifications',
  },
  profile: {
    tabs: {
      profile: 'Profile',
      theme: 'Theme',
    },
    theme: {
      primaryColor: 'Primary color',
      secondaryColor: 'Secondary color',
      font: 'Font',
      loginImage: 'Login image',
      favicon: 'favicon',
      loginPlaceholder: 'JPG or PNG, no larger than 10MB',
      name: 'name',
      save: 'Save',
      saveChanges: 'Save changes',
    },
    addProfile: 'Add Profile',
  },
  dropzoneInput: {
    placeholder: 'Add',
  },
  booking: {
    message: {
      success: 'Booking successful',
      error: 'Booking failed, please contact support',
    },
  },
  event: {
    message: {
      created: 'Event created successfully',
      updated: 'Event updated successfully',
    },
  },
  venue: {
    hotdesks_not_available: 'Hot desks are not available at this venue. Showing meeting rooms instead.',
    meetingrooms_not_available: 'Meeting rooms are not available at this venue. Showing hot desks instead.',
  },
}

export default translation
